import { apiClient } from '../client'
import type { ScanDiffResponse } from '../../app/modules/types/scanDiff'

export const scanDiffApi = {
  getAssetDiff: async (assetId: string, scanIds: string[]): Promise<ScanDiffResponse> => {
    const params = scanIds.join(',')
    const { data } = await apiClient.get(`/assets/${assetId}/scan-diff/?scan_ids=${params}`)
    return data
  },
  getIpDiff: async (ipId: string, scanIds: string[]): Promise<ScanDiffResponse> => {
    const params = scanIds.join(',')
    const { data } = await apiClient.get(`/ip/${ipId}/scan-diff/?scan_ids=${params}`)
    return data
  },
}
